import React, { useCallback } from 'react';
import { Box, Flex } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { RelativeTime } from '../../../../../common/ui/relative-time/index.tsx';
import { UserAvatar } from '../../../../../common/ui/user-avatar/index.tsx';
import {
	ActivityTypes,
	BoundaryIds,
	SectionIds,
	type Activity,
} from '../../../../../common/types.tsx';
import { ActivityMessage } from '../../../../../common/ui/activity-message/index.tsx';

import { useSectionAnalytics } from '../../../../../common/ui/analytics/index.tsx';
import messages from './messages.tsx';

export type AttachmentAddedProps = {
	activity: Activity<'ATTACHMENT_ADDED'>;
};

export const AttachmentAdded = ({
	activity: { created, issueData, author },
}: AttachmentAddedProps) => {
	const { formatMessage } = useIntl();
	const { fireSectionAnalytics } = useSectionAnalytics(
		SectionIds.RecentActivity,
		BoundaryIds.RecentActivity,
	);

	const onActivityItemClick = useCallback(
		(target: 'user' | 'issue') => {
			fireSectionAnalytics(target, {
				boundaryId: BoundaryIds.RecentActivity,
				activityType: ActivityTypes.ATTACHMENT_ADDED,
			});
		},
		[fireSectionAnalytics],
	);

	return (
		<Box>
			<Flex columnGap="space.100">
				<UserAvatar author={author} />
				<Flex direction="column" rowGap="space.050">
					<ActivityMessage author={author} issueData={issueData} onClick={onActivityItemClick}>
						{({ author: activityAuthor, issueLink }) =>
							formatMessage(messages.attachmentContent, {
								author: activityAuthor,
								issueLink,
							})
						}
					</ActivityMessage>
					<RelativeTime time={created} />
				</Flex>
			</Flex>
		</Box>
	);
};
